import dayjs, { Dayjs } from "dayjs"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import { IAccountSyncResult, IAccountSyncUser } from "./accountSyncResult.types"
import { Status } from "@/types/Status"

dayjs.extend(isSameOrAfter)

export class AccountSyncResult implements IAccountSyncResult {
  constructor(
    public number: string,
    public customerNumber: string,
    public juniferId: number,
    public coreId: number | undefined,
    public customerName: string,
    public balance: number,
    public fromDate: Dayjs | undefined,
    public toDate: Dayjs | undefined,
    public terminatedDate: Dayjs | undefined,
    public closedDate: Dayjs | undefined,
    public cancelledDate: Dayjs | undefined,
    public createdDate: Dayjs | undefined,
    public isSynced: boolean,
    public isAutoSynced: boolean,
    public isAutoSyncLocked: boolean,
    public autoSyncId: number | undefined,
    public users: IAccountSyncUser[],
  ) {}

  get status(): Status {
    const now = dayjs()

    if (this.cancelledDate?.isBefore(now)) {
      return new Status("default", "Cancelled")
    }
    if (
      !this.closedDate &&
      !this.terminatedDate &&
      !this.toDate &&
      this.fromDate?.isBefore(now)
    ) {
      return new Status("normal", "Active")
    }
    if (!this.toDate && this.fromDate?.isAfter(now)) {
      return new Status("neutral", "Transferring")
    }
    if (
      this.terminatedDate ||
      this.closedDate ||
      this.toDate?.isSameOrAfter(now)
    ) {
      return new Status("critical", "Closed")
    }
    if (this.toDate?.isBefore(now)) {
      return new Status("neutral", "Terminating")
    }
    return new Status("default", "Undetermined")
  }

  get autoSyncStatus(): Status {
    if (this.isAutoSyncLocked) return new Status("normal", "On (locked)")
    if (this.isAutoSynced && !this.isSynced) {
      return new Status("caution", "Setting up")
    }
    if (this.isAutoSynced && this.isSynced) return new Status("normal", "On")
    return new Status("critical", "Off")
  }

  get hasUser(): boolean {
    return !!this.users.length
  }

  get isOccupierAccount(): boolean {
    return this.customerName.startsWith("The Occupier")
  }

  get isQaAccount(): boolean {
    return (
      this.hasUser &&
      this.users.some((user) => user.email?.includes("automation"))
    )
  }
}
